import i18n from "i18next";
import { initReactI18next } from "react-i18next";
//import Backend from 'i18next-http-backend';
import HttpApi from "i18next-http-backend";

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    //lng: "da",
    fallbackLng: "da",
    //ns: ['common', 'about', 'contact', 'dashboard', 'customercases'],
    ns: ["global"],
    defaultNS: "common",
    whitelist: ["en", "da"],
    load: 'languageOnly',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    react: {
      useSuspense: true,
    },
    saveMissing: true, // <--- enable missing key reporting
    missingKeyHandler: (lng, ns, key) => {
      console.warn(`Missing translation: [${lng}/${ns}] → ${key}`);
    },
    nsSeparator: ":",
    keySeperator: ".",
    debug: true, // <--- optional: logs loading, missing keys etc. to console
});

export default i18n;